import React from 'react'

const Categorias = () => {
  return (
    <div className='flex h-screen text-xl'>CATEGORIAS
    <div className='flex h-screen'></div></div>
  )
}

export default Categorias